// extracted by mini-css-extract-plugin
export default {"wrapperBlock":"ButtonWithSvg_wrapperBlock__qFhKs"};